module.exports = __webpack_public_path__ + "2b7bca3d61ab9b494a9bdc9a8d142d3c.jpg";